module.exports = __webpack_public_path__ + "media/images/pc/specials/common/store_tachikawa-01e179f7aff0851183a3d24ab4261c9f.jpg";